import { Capacitor } from "@capacitor/core";

/**
 * SULL'APP PER IPHONE: ISCRIZIONE SÌ, INVITI A COMPRARE NO (Apple 3.1.1).
 *
 * Il 29/09/2026 Apple ha respinto la build 8: «The app includes an account
 * registration feature for businesses and organizations, which is considered
 * access to external mechanisms for purchases». Il punto non era l'iscrizione:
 * era il muro dopo i 7 giorni, con «richiedi l'attivazione a Datacom» e i tasti
 * che portavano alla richiesta. Per Apple quello è un invito a comprare fuori.
 *
 * Decisione di Davide (29/09): l'iscrizione resta nell'app anche su iPhone, e
 * crea un account GRATUITO che non scade (gli strumenti restano sempre liberi,
 * come le app «gratis + abbonamento sul sito»: Spotify, Slack). Dentro l'app
 * iOS però nessun prezzo, nessun tasto o testo che porti a richiedere o
 * comprare l'account installatore: la licenza si propone FUORI dall'app (mail
 * di benvenuto e del 5° giorno, Datacom al telefono), che Apple consente.
 *
 * Il sito e l'app Android restano come sono.
 */
export function invitiAllAcquistoNellApp(): boolean {
  return Capacitor.getPlatform() !== "ios";
}

/** Testi neutri per l'iPhone, al posto di quelli che mandano a Datacom per l'attivazione. */
export const TESTI_IOS = {
  valutazioneFinita:
    "Il periodo di valutazione dell'assistente è terminato. Gli strumenti di calcolo restano a tua disposizione.",
  accessoNonAttivo:
    "L'assistente non è attivo per il tuo account in questo momento. Gli strumenti di calcolo restano a tua disposizione.",
  quotaSettimana: "Hai raggiunto le domande di questa settimana: il conteggio riparte lunedì.",
  quotaValutazione: "Hai usato le domande del periodo di valutazione. Gli strumenti di calcolo restano a tua disposizione.",
} as const;

/** Il riquadro sopra «Crea account» sull'iPhone: cosa si riceve, senza dire cosa succede "dopo". */
export const TESTO_ISCRIZIONE_IOS = (marchi: readonly string[]): string =>
  `Con la registrazione crei un account che non scade: gli strumenti di calcolo restano sempre a tua disposizione, e per i primi 7 giorni hai anche l'assistente tecnico su ${marchi.join(", ")}. La partita IVA ci serve per riconoscere le imprese installatrici: la controlliamo noi, non devi aspettare nessuno.`;

/**
 * La risposta del motore sui marchi fuori dall'accesso arriva gia' scritta dal
 * server (Dify, nodo codice), che non sa da che piattaforma parte la domanda:
 * «X non è incluso nel tuo abbonamento… Per aggiungere un marchio, scrivi a
 * Datacom.» Sull'iPhone si toglie l'invito e la parola «abbonamento» (01/10).
 */
export function rispostaPerQuestaApp(testo: string): string {
  if (invitiAllAcquistoNellApp()) return testo;
  return testo
    .replace(/\s*Per aggiungere (?:un|altri) marc\w*,? scrivi a Datacom\.?/gi, "")
    .replace(/nel tuo abbonamento/gi, "nel tuo accesso");
}

/**
 * SULL'IPHONE NIENTE ISCRIZIONE (Apple 3.1.1, terzo rifiuto, 03/10/2026).
 *
 * Tolti tutti gli inviti, Apple ha respinto anche la build 123 con le stesse
 * parole: «Remove the account registration features for business and
 * organizations». Decisione di Davide (03/10): sull'iPhone l'app fa entrare chi
 * l'account ce l'ha gia' (anche con Google o Apple) e lascia liberi a tutti gli
 * strumenti di calcolo; l'account si crea FUORI dall'app (sito, QR al banco,
 * mail e firme di Datacom). Niente link all'iscrizione dentro l'app: per Apple
 * e' la stessa cosa. Sito e Android tengono l'iscrizione.
 */
export function iscrizioneNellApp(): boolean {
  return Capacitor.getPlatform() !== "ios";
}
